import { render, staticRenderFns } from "./HlaTyping.vue?vue&type=template&id=3f253b94"
import script from "./HlaTyping.vue?vue&type=script&lang=ts"
export * from "./HlaTyping.vue?vue&type=script&lang=ts"
import style0 from "./HlaTyping.vue?vue&type=style&index=0&id=3f253b94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./_locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fhla%2FHlaTyping.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./_locales/HlaTyping.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fhla%2FHlaTyping.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports